import { 
    useTheme,
    useMediaQuery,
    Box,
    FormControl,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import LoginMessage from './advanced/LoginMessage';

const Period = ({ days, handleDaysChange }) => {
    const theme = useTheme();
    const user = useSelector(state => state.user.value);
    return (
        <Box className="container-card">
            <Box className="square" sx={{ 
                boxShadow: theme.palette.squareBoxShadow,
                display:'flex', justifyContent: 'center', alignItems: 'center', 
                border: '0.3px solid #AAB4BE',
            }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2}}>
                    <FormControl sx={{width: {xs: '75%', sm: '70%'}, height: '75%', display: 'flex', flexDirection: 'column', gap: 2}}>
                        <Typography component="div" fontSize='22px'>
                            Active period
                        </Typography>
                        <TextField
                            id="outlined-number"
                            label="Amount of days"
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={days}
                            onChange={handleDaysChange}
                            variant="standard" 
                        />
                        <PeriodOptions 
                            days={days} 
                            handleDaysChange={handleDaysChange} 
                        />
                    </FormControl>
                    {
                        !user?.isLogined && 
                        <Box sx={{width: '90%', display: 'flex', justifyContent: 'center'}}>
                            <LoginMessage message={<span>To shorten for <i>indefinite</i> period please</span>} />
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
}

const periodOptions = [
    {value: 1, label: "1 day", shortLabel: "1d"},
    {value: 3, label: "3 days", shortLabel: "3d"},
    {value: 7, label: "1 week", shortLabel: "1w"},
    {value: 14, label: "2 weeks", shortLabel: "2w"},
    {value: 31, label: "1 month", shortLabel: "1m"},
    {value: 91, label: "3 months", shortLabel: "3m"},
    {value: 181, label: "6 months", shortLabel: "6m"},
    {value: 365, label: "1 year", shortLabel: "1y"},
    {value: 1095, label: "3 years", shortLabel: "3y", isLogined: true},
    {value: '', label: "Indefinite", shortLabel: "Ind", isLogined: true},
];

const PeriodOptions = ({ days, handleDaysChange }) => {

    const theme = useTheme();
    const matchesSm = useMediaQuery(theme.breakpoints.down(365));

    const user = useSelector(state => state.user.value);

    const filteredPeriodOptions = periodOptions.filter(option => (
        !option?.isLogined || (user?.isLogined && option?.isLogined) 
    ));
    const periodColumnLength = filteredPeriodOptions.length;

    const getChunkPeriodOptions = ({ start = 0, end = undefined }) => {
        return (
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                {
                    filteredPeriodOptions.slice(start, end).map(current => {
                        return (
                            <FormControlLabel 
                                control={<Radio />} 
                                key={current.value}
                                value={current.value} 
                                label={matchesSm ? current.shortLabel : current.label} 
                                componentsProps={{
                                    typography: { 
                                        fontWeight: days == current.value ? "bold" : "normal",
                                    },
                                }}
                            />
                        );
                    })
                }
            </Box>
        );
    }

    const getAllOptions = () => {
        return (
            <>
                { getChunkPeriodOptions({ end: Math.floor(periodColumnLength / 2) }) }
                { getChunkPeriodOptions({ start: Math.ceil(periodColumnLength / 2) }) }
            </>
        );
    }

    return (
        <RadioGroup
            value={days}
            onChange={handleDaysChange}
        >   
            <Box sx={{display: 'flex', justifyContent: 'space-around'}}>
                { getAllOptions() }
            </Box>
        </RadioGroup>
    );
}

export {
    periodOptions,
}

export default Period;